import { Injectable } from '@angular/core';
import { shareReplay, tap } from 'rxjs/operators';
import { ConfigurationHttpClient } from '../httpclient/configuration.httpclient';
import { EMPTY, Observable } from 'rxjs';
import { EMPTY_GLOBALS, Globals } from '../models/globals';

@Injectable({ providedIn: 'root' })
export class GlobalsService {
  private _configuration$: Observable<Globals> = EMPTY;
  public configuration: Globals = EMPTY_GLOBALS;

  public constructor(private readonly configurationHttpClient: ConfigurationHttpClient) {}

  public get urlFrontShopHubbix(): string {
    return this.configuration.urlFrontShopHubbix;
  }
  public get isProduction(): boolean {
    return this.configuration.production;
  }

  public get onTrustTokenId(): string {
    return this.configuration.onTrustTokenId;
  }

  private get _configFile(): string {
    return `assets/configuration.json`;
  }

  /**
   * Retourne la configuration propre à l'environnement
   */
  public load(): Observable<Globals> {
    if (this._configuration$ === EMPTY) {
      this._configuration$ = this.configurationHttpClient.get<Globals>(this._configFile).pipe(
        shareReplay(1),
        tap((configuration: Globals) => {
          this.configuration = { ...configuration };
        }),
      );
    }
    return this._configuration$;
  }

  public createClarityElements(GlobalsCode: string): void {
    const scriptClarity: HTMLScriptElement = document.createElement('script');
    scriptClarity.src = 'https://d.clarity.ms/s/0.6.32/clarity.js';

    const scriptTag = document.createElement('script');
    scriptTag.id = 'clarity';
    scriptTag.type = 'text/javascript';
    scriptTag.textContent = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${GlobalsCode}");`;

    document.getElementsByTagName('head')[0].append(scriptClarity);
    document.getElementsByTagName('head')[0].append(scriptTag);
  }
}
